"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const App_vue_1 = require("../App.vue");
const Shared_1 = require("../../../shared/Shared");
const User_1 = __importStar(require("../../../shared/User"));
class UsersDataClass {
    constructor() {
        this.UserList = [];
        this.Councils = [];
    }
}
exports.default = vue_1.default.extend({
    name: "Users",
    data() {
        return new UsersDataClass();
    },
    created() {
        this.ReloadData();
    },
    computed: {
        roles() {
            const result = [];
            for (const key of Object.keys(User_1.roles)) {
                result.push(key);
            }
            return result;
        },
    },
    methods: {
        CreateUser() {
            var _a, _b;
            const user = new User_1.default();
            user.data.email = (_a = prompt("Enter the user's email address")) !== null && _a !== void 0 ? _a : "";
            if (!user.data.email) {
                return;
            }
            user.password = (_b = prompt("Enter the user's initial password")) !== null && _b !== void 0 ? _b : "";
            if (!user.password) {
                return;
            }
            this.Save(user);
        },
        SetDirty(user) {
            user.dirty = true;
            this.$forceUpdate();
        },
        DisplayName(user) {
            let result = user.data.email;
            if (user.data.displayName) {
                result = user.data.displayName;
            }
            if (user.dirty) {
                result += "*";
            }
            return result;
        },
        Delete(user) {
            if (!confirm("Are you sure you wish to delete this user?")) {
                return;
            }
            App_vue_1.AjaxDelete(Shared_1.GetUserURL(user.uid))
                .then(() => {
                this.ReloadData();
            })
                .catch((err) => App_vue_1.Alert("Could not delete user", err));
        },
        Save(user) {
            App_vue_1.AjaxPost(Shared_1.GetUserURL(), user, true)
                .then(() => {
                this.ReloadData();
            })
                .catch((err) => App_vue_1.Alert("Could not save user", err));
        },
        ReloadData() {
            App_vue_1.GetClients()
                .then((result) => {
                this.Councils = Object.keys(result);
                return App_vue_1.AjaxGet(Shared_1.GetAllUsersURL(), true);
            })
                .then((result) => {
                this.UserList.length = 0;
                for (const obj of Object.values(result)) {
                    this.UserList.push(obj);
                }
                this.UserList.sort((a, b) => this.DisplayName(a) > this.DisplayName(b)
                    ? 1
                    : this.DisplayName(b) > this.DisplayName(a)
                        ? -1
                        : 0);
                this.$forceUpdate();
            })
                .catch((err) => App_vue_1.Alert("Cannot load users", err));
        },
    },
});
